
const TAROT_WEBSITE_LINK = 'https://www.tarot.to';
const TAROT_TWITTER_LINK = 'https://twitter.com/TarotFinance';
const TAROT_DISCORD_LINK = 'https://discord.gg/6ByFHBjqE8';
const TAROT_MEDIUM_LINK = 'https://tarotfinance.medium.com';
const TAROT_GIT_HUB_LINK = 'https://github.com/tarot-finance';
const TAROT_GITBOOK_LINK = 'https://docs.tarot.to';

export {
  TAROT_TWITTER_LINK,
  TAROT_WEBSITE_LINK,
  TAROT_DISCORD_LINK,
  TAROT_MEDIUM_LINK,
  TAROT_GIT_HUB_LINK,
  TAROT_GITBOOK_LINK
};
